module.exports = __webpack_public_path__ + "img/mision.10b75945.jpg";